export const MagicLinkPurpose = Object.freeze({
  POLICY_SIGN: 'POLICY_SIGN',
  CAMPAIGN_LANDING: 'CAMPAIGN_LANDING',
});

export const MagicLinkRedirectPath = Object.freeze({
  POLICY_SIGN_DOCUMENT_PREFIX: '/document',
  CAMPAIGN_LANDING_PREMIUM_PEOPLE: '/upgrade/premium-people',
  CAMPAIGN_LANDING_TRIAL_PREMIUM_PEOPLE: '/trial/premium-people',
  CAMPAIGN_LANDING_MIGRATION: '/migration',
});

const OBJECT_ID_PATH_SEGMENT = '[a-fA-F0-9]{24}';

export const MagicLinkRedirectPattern = Object.freeze({
  POLICY_SIGN_DOCUMENT: new RegExp(
    `^${MagicLinkRedirectPath.POLICY_SIGN_DOCUMENT_PREFIX}/${OBJECT_ID_PATH_SEGMENT}$`
  ),
});

// Exact landing routes a CAMPAIGN_LANDING magic link may auto-redirect to after
// auth. This mirrors the server-side allowlist in core (BIO-1257); both gates
// must agree. Add a campaign's route here to let the app honor its magic-link
// redirect.
export const CampaignLandingRedirectPaths = Object.freeze([
  MagicLinkRedirectPath.CAMPAIGN_LANDING_PREMIUM_PEOPLE,
  MagicLinkRedirectPath.CAMPAIGN_LANDING_TRIAL_PREMIUM_PEOPLE,
  MagicLinkRedirectPath.CAMPAIGN_LANDING_MIGRATION,
]);
